import { useState } from 'react';


        // One-line "add Veil to your Home Screen" hint for iPhone and iPad.
        // iOS has no install prompt of its own: the only route is Share → Add
        // to Home Screen, which nobody finds unaided. Shown once per device
        // in Safari on iOS/iPadOS when the page is not already installed
        // (navigator.standalone is false); dismissing it sticks. Android and
        // desktop browsers offer their own install UI, so nothing shows there.
        const isAppleTouch = () => {
            try {
                const ua = navigator.userAgent || '';
                const iPadOS = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
                return /iPhone|iPad|iPod/.test(ua) || iPadOS;
            } catch (e) { return false; }
        };
        const KEY = 'veil_install_hint';
        function InstallHint() {
            const [show, setShow] = useState(() => {
                try {
                    if (!isAppleTouch()) return false;
                    if (window.navigator.standalone === true) return false;               // already installed
                    if (window.matchMedia('(display-mode: standalone)').matches) return false;
                    return localStorage.getItem(KEY) !== 'dismissed';
                } catch (e) { return false; }
            });
            if (!show) return null;
            const dismiss = () => { try { localStorage.setItem(KEY, 'dismissed'); } catch (e) { /* ignore */ } setShow(false); };
            return (
                <div role="note" className="text-xs" style={{
                    display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap',
                    padding: '8px 14px', background: 'var(--zone-2)', borderBottom: '1px solid var(--rule)', color: 'var(--text-soft)',
                }}>
                    <span style={{ color: 'var(--gold)' }}>Add Veil to your Home Screen:</span>
                    <span>tap Share <span aria-hidden="true">⎋</span> then <b style={{ color: 'var(--text)' }}>Add to Home Screen</b>. It then opens full screen like an app.</span>
                    <button type="button" onClick={dismiss} aria-label="Dismiss"
                            style={{ marginLeft: 'auto', background: 'transparent', border: '1px solid var(--rule-2)', borderRadius: 6, color: 'var(--text-muted)', padding: '4px 10px', cursor: 'pointer' }}>
                        Got it
                    </button>
                </div>
            );
        }

export { InstallHint };
